import { render, staticRenderFns } from "./AbstractsTable.vue?vue&type=template&id=1c79c74d&scoped=true"
import script from "./AbstractsTable.vue?vue&type=script&lang=js"
export * from "./AbstractsTable.vue?vue&type=script&lang=js"
import style0 from "./AbstractsTable.vue?vue&type=style&index=0&id=1c79c74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79c74d",
  null
  
)

export default component.exports